<template src="./index.html"></template>
<script>
import minhead from '../../../common/minHead/index.vue';
import { getdata } from './data.js';
import {
  selectRoles,
  createRole,
  selectUsers,
  deletes,
  selectNotGlUsers,
  saveRoleUser,
  ResourceTableList,
  TreeListByRoleId,
  saveAuthResource,
  DeptTreeTableList,
  ScopeDeptIds,
  rolesave, copyRole, selectTaskData, sendExportRole
} from '../../../../api/permissionManagement.js';
import config from "../../../../../configHttp";
import companyPermissionMode from '@/mixins/companyPermissionMode';
import dataScopeOptions from '../dataScopeOptions';
export default {
	mixins: [companyPermissionMode],
	name: 'qxsz',
	components: {
		minhead
	},
	data: function() {
		return {
			tablekey: 0,
			headData: getdata().headData,
			tableData: getdata().tableData,
			pagination: getdata().pagination,
			data: [],
			defaultProps: {
				children: 'children',
				label: 'label'
			},
			options: dataScopeOptions,
			value: '1',
			choosetreeid: {},
			//新建分组
			groupdiag: false,
			outlist: null,
			//新建角色
			rolediag: false,
			Roleformlist: getdata().Roleformlist,
			Roleformdata: getdata().Roleformdata,
			//添加移除成员
			updatememberdiag: false,
			headDatanochoose: getdata().headDatanochoose,
			tableDatanochoose: [],
			headDatachoose: getdata().headDatachoose,
			tableDatachoose: [],
			tableDatas: [],

			//详情
			chooseindex: 0,
			allowDrop: null,
			allowDrag: null,
			Groupname: '',
			typedata: {
				type: ''
			},
			selectoption: '',
			codegoole: '',
			taballData: [
				{
					label: '角色成员'
				},
				{
					label: '数据权限'
				},
				{
					label: '功能权限'
				}
			],
			outBulletframe: {
				left: [],
				right: []
			},
			sid: '',
			copyRoleDiag: false,
			copyRoleId: undefined,
			copyRoleformlist: getdata().copyRoleformlist,
			copyRoleformdata: getdata().copyRoleformdata,
			viewTaskDiag: false,
			taskData: getdata().taskData,
			taskTableData: [],
			taskPagination:{
				pageNum: 1,
				pageSize: 50,
				total: 0,
				paginationkey: 0
			}
		};
	},
	mounted() {
		this.getlist();
		this.getlist('0');
	},
	created() {},
	methods: {
		role() {
			// if(this.typedata.type&&this.typedata.type==0){
			Object.keys(this.Roleformdata).map(key => {
				this.Roleformdata[key] = '';
			});
			this.rolediag = true;
			this.$refs.taxform.clearValidate();
			// }else{
			// 	this.$message.error('新建角色只能挂靠在分组下')
			// }
		},
		nextgroupdiag() {
			this.groupdiag = true;
			this.Groupname = '';
		},
		forchooseitems(node, data) {
			this.sid = data.id;
		},
		forchooseitem(node, data) {
			this.typedata = data;
			this.choosetreeid = {
				id: data.id,
				name: data.roleName
			};
			this.value = data.dataScope;
			this.outlist = {
				groupType: data.groupType,
				type: data.type,
				parentId: data.parentId
			};
			if (data.parentId == '1' && data.type == '1') {
				this.chooseindex = '0';
			}
			if (this.chooseindex == '0') {
				this.leftlist();
			} else if (this.chooseindex == '1') {
				this.DeptList();
			} else {
				this.TableList();
			}
		},
		fun(value, arr) {
			value.map(item => {
				arr.map(item1 => {
					if (item.id == item1) {
						item.color = true;
					}
				});
				if (item.children != null) {
					this.fun(item.children, arr);
				}
			});
		},
		DeptList() {
			if (this.companyPermissionMode !== 'LEGACY') return;
			DeptTreeTableList().then(res => {
				if (res.data.code == 1) {
					this.tableDatas = res.data.data;
					let params = {
						dataScope: this.value,
						roleId: this.choosetreeid.id
					};
					ScopeDeptIds(params).then(res => {
						if (res.data.code == 1) {
							if (this.companyPermissionMode !== 'LEGACY') return;
							this.chooseindex = '1';
							setTimeout(v => {
								if (this.companyPermissionMode === 'LEGACY' && this.$refs.trees) this.$refs.trees.setCheckedKeys(res.data.data);
							}, 10);
							this.fun(this.tableDatas, res.data.data);
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		qiehuan(index, item) {
			if (index == 1 && this.companyPermissionMode !== 'LEGACY') return;
			if (index == '0') {
				this.leftlist();
				this.chooseindex = '0';
			} else if (index == '1') {
				this.DeptList();
			} else {
				this.TableList();
			}
		},
		TableList() {
			ResourceTableList().then(res => {
				if (res.data.code == 1) {
					this.tableData = res.data.data;
					let params = {
						roleId: this.choosetreeid.id
					};
					TreeListByRoleId(params).then(res => {
						if (res.data.code == 1) {
							let parentIds = [];
							let ids = [];
							let leng = 0;
							this.chooseindex = '2';
							// this.tableData.map(item0=>{
							// 	parentIds.push(item0)
							// 	if(item0.children.length!=0){
							// 		ids.push(item0.id)
							// 		item0.children.map(item1=>{
							// 			parentIds.push(item1)
							// 			if(item1.children.length!=0){
							// 				ids.push(item1.id)
							// 				item1.children.map(item2=>{
							// 					parentIds.push(item2)
							// 				})
							// 			}
							// 		})
							// 	}
							// })
							dg(this.tableData);
							function dg(value) {
								value.map(item => {
									if (item.children.length != 0) {
										ids.push(item.id);
										dg(item.children);
									}
								});
							}
							ids.map(itemid => {
								res.data.data.map((item, index) => {
									if (item == itemid) {
										res.data.data.splice(index,1);
									}
								});
							});
							setTimeout(v => {
								this.$refs.tree.setCheckedKeys([]);
								this.$refs.tree.setCheckedKeys(res.data.data);
							}, 10);
							this.fun(this.tableData, res.data.data);
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		saveCheckedKeys() {
			if (this.companyPermissionMode !== 'LEGACY') return;
			let list = this.$refs.trees.getCheckedKeys()
			let params = {
				id: this.choosetreeid.id,
				deptIds: list,
				dataScope: this.value
			};
			if (this.value != 2) {
				delete params.deptIds;
			}
			rolesave(params).then(res => {
				if (res.data.code == 1) {
					this.$message.success('保存成功');
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		getCheckedKeys() {
			let fu = this.$refs.tree.getHalfCheckedKeys();
			let resIds = this.$refs.tree.getCheckedKeys();
			for (let a = 0; a < fu.length; a++) {
				for (let b = 0; b < resIds.length; b++) {
					if (resIds[b] == fu[a]) {
						break;
					} else {
						if (b == resIds.length - 1) {
							resIds.push(fu[a]);
							break;
						}
					}
				}
			}
			let params = {
				roleId: this.choosetreeid.id,
				resIds
			};
			saveAuthResource(params).then(res => {
				if (res.data.code == 1) {
					this.$message.success('保存成功');
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		nextgroup() {
			if (this.$emptyandnull(this.Groupname)) {
				this.$message.error('分组名称不能为空');
			} else {
				let params = {
					roleName: this.Groupname,
					type: '0'
				};
				this.newrolgrou(params);
			}
		},

		deleteorl(data) {
			if (data.type == 0) {
				if (data.children.length != 0) {
					this.$message.error('请先移除当前分组下的角色再进行删除');
					return;
				}
			}
			let params = {
				id: data.id
			};
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					deletes(params).then(res => {
						if (res.data.code == 1) {
							this.$message.success('删除成功');
							this.pagination.pageNum = 1;
							this.pagination.paginationkey++;
							this.getlist();
							this.getlist('0');
						} else {
							this.$message.error(res.data.msg);
						}
					});
				}
			});
		},

		nextrole() {
			this.$refs.taxform.submitForm();
		},
		getdata() {
			let params = {
				...this.Roleformdata,
				type: '1'
			};
			this.newrolgrou(params);
		},
		newrolgrou(params) {
			createRole(params).then(res => {
				if (res.data.code == 1) {
					this.getlist();
					if (params.type == '1') {
						this.$message.success('新建角色成功');
						this.rolediag = false;
					} else {
						this.$message.success('新建分组成功');
						this.getlist('0');
						this.groupdiag = false;
					}
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},

		getlist(e) {
			let params = {
				type: e || '1'
			};
			selectRoles(params).then(res => {
				if (res.data.code == 1) {
					if (e == '0') {
						let list = res.data.data.map(item => {
							return {
								label: item.roleName,
								value: item.id
							};
						});
						this.Roleformlist[1].selectval = list;
					} else {
						this.data = res.data.data;
						this.typedata = res.data.data[0].type;
						this.choosetreeid.id = res.data.data[0].id;
						this.choosetreeid.name = res.data.data[0].roleName;
						this.outlist = {
							groupType: res.data.data[0].groupType,
							type: res.data.data[0].type,
							parentId: res.data.data[0].parentId
						};
						this.leftlist();
					}
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},

		outsearch() {
			this.choosetreeid.sousuo = this.selectoption;
			this.outleft();
		},
		updatemember(data) {
			this.selectoption = '';
			this.tableDatanochoose = [];
			this.tableDatachoose = [];
			this.choosetreeid.ids = data.id;
			this.leftlist(1);
			this.outleft();
			this.updatememberdiag = true;
		},
		outleft() {
			let params = {
				roleId: this.choosetreeid.ids,
				queryParam: this.choosetreeid.sousuo || ''
			};
			selectNotGlUsers(params).then(res => {
				if (res.data.code == 1) {
					this.tableDatanochoose = res.data.data;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		outSubmit() {
			//提交成员
			let arr = [];
			this.tableDatachoose.forEach(item => {
				arr.push(item.userId);
			});
			let params = {
				id: this.choosetreeid.ids,
				userIds: arr
			};
			saveRoleUser(params).then(res => {
				if (res.data.code == 1) {
					this.$message.success('编辑成员成功');
					this.updatememberdiag = false;
					if (this.choosetreeid.ids == this.choosetreeid.id) {
						this.leftlist();
					}
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		rightactive() {
			for (let a = 0; a < this.tableDatanochoose.length; a++) {
				for (let b = 0; b < this.outBulletframe.left.length; b++) {
					if (this.tableDatanochoose[a].userId == this.outBulletframe.left[b].userId) {
						this.tableDatachoose.unshift(this.tableDatanochoose[a]);
						this.tableDatanochoose.splice(a, 1);
					}
				}
			}
		},
		leftactive() {
			for (let a = 0; a < this.tableDatachoose.length; a++) {
				for (let b = 0; b < this.outBulletframe.right.length; b++) {
					if (this.tableDatachoose[a].userId == this.outBulletframe.right[b].userId) {
						this.tableDatanochoose.unshift(this.tableDatachoose[a]);
						this.tableDatachoose.splice(a, 1);
					}
				}
			}
		},
		selectionchange(e) {
			this.outBulletframe.left = e;
		},
		selectionchangeright(e) {
			this.outBulletframe.right = e;
		},
		leftlist(e) {
			//相关成员  共选择的相关成员
			let params = {};
			if (!e) {
				params = {
					roleId: this.choosetreeid.id,
					queryParam: this.pagination.activeSearch //搜索框信息
				};
			} else {
				params = {
					roleId: this.choosetreeid.ids
				};
			}
			selectUsers(params).then(res => {
				if (res.data.code == 1) {
					if (!e) {
						this.tableData = res.data.data;
					} else {
						this.tableDatachoose = res.data.data;
					}
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		sizechange(e) {
			//页码切换
			this.pagination.pageSize = e;
			this.leftlist(); //调用分页查询
		},
		currentChange(e) {
			//页码切换
			this.pagination.pageNum = e;
			this.leftlist(); //调用分页查询
		},
		search() {
			//点击搜索
			this.pagination.activeSearch = JSON.parse(JSON.stringify(this.codegoole)); //点击了搜索按钮赋值用于比对是否点击搜索
			this.pagination.pageNum = 1;
			this.leftlist(); //调用搜索按钮
		},
		forback() {
			this.$router.go(-1);
		},
		exportRole() {
			sendExportRole({}).then(res => {
				if (res.data.code == 1) {
					this.$message.success('请求成功,请通过任务查看页面查询进度和下载');
				} else {
					this.$message.error(res.msg);
				}
			});

			// let params = {
			// 	downUrl: config.baseURL + "sys/exportRole",
			// 	typeObj: {
			// 	toForm: true,
			// 	fileType: "xlsx",
			// 	fileName: "权限管理数据"
			// 	}
			// };
			// this.$downloadcommon(params);

		},
		copyRole(data) {
		Object.keys(this.copyRoleformdata).map(key => {
			this.copyRoleformdata[key] = '';
		});
		this.copyRoleDiag = true;
		this.copyRoleId = data.id;
		this.$refs.copyTaxform.clearValidate();
		},
		nextcopyRole() {
		this.$refs.copyTaxform.submitForm();
		},
		getCopyData() {
		let params = {
			...this.copyRoleformdata,
			copyRoleId: this.copyRoleId
		};
		copyRole(params).then(res => {
			if (res.data.code === 1) {
			this.copyRoleDiag = false;
			this.getlist();
			this.getlist('0');
			this.$message.success('复制成功');
			} else {
			this.$message.error(res.data.msg);
			}
		});
		},
		viewExportTask(){
			this.viewTaskDiag = true;
			this.taskPagination.pageNum = 1;
			this.getExportTaskData();
		},
		getExportTaskData() {
			let params = {};
			params.current = this.taskPagination.pageNum;
			params.size = this.taskPagination.pageSize;
			selectTaskData(params).then(res => {
				if (res.data.code == 1) {
					this.taskPagination.total = res.data.data.total
					this.taskTableData = res.data.data.records;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		handleCommand(command) {
      		switch(command)  {
				case 'exportRole':
					this.exportRole();
				 	break;
				case 'viewExportTask':
					this.viewExportTask();
					break
			}
		},
		downloadFile(row) {
			let params = {
				downUrl: config.baseURL + "sys/exportRole",
				typeObj: {
					toForm: true,
					fileType: "xlsx",
					fileName: "权限管理数据"
				},
				params: {
					id: row.id
				},
			};
			this.$downloadcommon(params);
		},
		taskSizechange(e) {
			//页码切换
			this.taskPagination.pageSize = e;
			this.getExportTaskData();
		},
		taskCurrentChange(e) {
			//页码切换
			this.taskPagination.pageNum = e;
			this.getExportTaskData();
		},
		taskForRefresh() {
			this.getExportTaskData();
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
